import { EHeadingStyleVariant, GeneralCameraOffIcon, Heading } from '@outdoorsyco/bonfire';
import cn from 'classnames';
import { useState } from 'react';

import Link from '@/components/switchback/Link/Link';
import ResponsiveImage from '@/components/utility/ResponsiveImage/ResponsiveImage';
import { useBreakpoint } from '@/hooks/useBreakpoint';
import { ICampgroundCategory } from '@/services/types/bundles/id';

const ImageFallback = ({ className }: { className?: string }) => (
  <div className={cn('flex items-center justify-center w-full h-full', className)}>
    <GeneralCameraOffIcon className="text-6xl" />
  </div>
);

export const CategoryItem = ({ display_name, image_url, slug }: ICampgroundCategory) => {
  const { isMobile } = useBreakpoint();
  const [isError, setIsError] = useState(false);

  const imageClassName = 'absolute inset-0 object-cover w-full h-full';

  return (
    <Link
      href={`/escapes/category/${slug}`}
      legacy
      forceClientsideRouting
      target={!isMobile ? '_blank' : undefined}>
      <div className="relative flex flex-col p-2 overflow-hidden md:p-4 rounded-2xl aspect-[4/5]">
        {!isError ? (
          <ResponsiveImage
            src={image_url}
            onError={() => setIsError(true)}
            alt={display_name}
            className={imageClassName}
            loading="lazy"
          />
        ) : (
          <ImageFallback className={imageClassName} />
        )}
        <div className="relative z-10 flex flex-col justify-end h-full">
          <Heading
            variant={EHeadingStyleVariant.H5}
            className="font-medium text-white text-500 md:text-[20px]">
            {display_name}
          </Heading>
        </div>
        <div className="absolute inset-0 bg-black/20 rounded-2xl" />
      </div>
    </Link>
  );
};
